export const getLanguageKeys = state => state.languages.keys
export const getLanguageCode = state => state.languages.code
export const getTranslation = state => { 
  const { keys } = state.languages
  return ( key ) => keys[key] || key
}


// WEBPACK FOOTER //
// ./src/store/getters/language.js